/* Cloudlift product-options tooltips, brought in line with the theme's.
   (2026-09-16)

   The app builds a Tippy v6 instance per swatch (its _initTooltips: content from
   data-tippy-content, appended to <body>, no theme) and its swatch template
   pins data-tippy-placement="bottom", so the tip opened under the pointer and
   the hand covered it. The app's admin has no per-option placement control we
   can drive from the store, so the theme re-points each instance once it
   exists: above the swatch, our palette (theme "artisticases", styled in
   artisticases-ui.css), a small gap. Instances are exposed on element._tippy;
   the attribute is rewritten too so any instance created later reads "top". */
(function () {
  'use strict';
  var SEL = '.cl-po--swatch[data-tippy-content], .cl-po [data-tippy-content], [class*="cl-po--"][data-tippy-content]';
  var PROPS = { placement: 'top', theme: 'artisticases', offset: [0, 8], animation: 'fade', duration: [160, 100], maxWidth: 260 };

  function patch(el) {
    if (el.getAttribute('data-tippy-placement') !== 'top') el.setAttribute('data-tippy-placement', 'top');
    var inst = el._tippy;
    if (!inst || inst.__acPatched) return;
    inst.__acPatched = true;
    try {
      if (typeof inst.setProps === 'function') inst.setProps(PROPS);
      else if (typeof inst.set === 'function') inst.set(PROPS);
    } catch (e) { /* older bundle: leave the app's defaults */ }
  }

  var pending = false;
  function run() {
    pending = false;
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) patch(els[i]);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(run);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  /* the app creates the instance lazily around first render; a hover on the
     swatch before the observer has caught up still gets the right placement */
  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest && e.target.closest(SEL);
    if (el) patch(el);
  }, true);
})();
